import { ElMessage } from "element-plus";
import IP from "../api/httpUrl";
export function getIsLogin() {
  return localStorage.getItem(IP.localKey) !== null;
}

export function checkPhone(phone) {
  return /^1[3-9]\d{9}$/.test(phone);
}

export function checkPhoneRule(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入手机号"));
  } else {
    if (!checkPhone(value)) {
      callback(new Error("请输入正确的手机号"));
    }
    callback();
  }
}

export function formatPhone(phone) {
  if (typeof phone !== "string" || phone.length !== 11) {
    return phone;
  }
  return phone.slice(0, 3) + "xxxx" + phone.slice(7);
}

export function beforeUploadFn(file) {
  // 检查文件类型
  const fileName = file.name;
  const isImage =
    file.type === "image/jpeg" ||
    file.type === "image/png" ||
    file.type === "image/jpg";
  const isLt5M = file.size / 1024 / 1024 < 5; // 限制文件大小为 1MB

  if (!isImage) {
    ElMessage({
      message: "只能上传 JPG、JPEG 或 PNG 格式的图片!",
      type: "warning",
    });
    return false;
  }

  if (!fileName) {
    ElMessage({
      message: "文件名不能为空!",
      type: "warning",
    });
    return false;
  }

  if (!isLt5M) {
    ElMessage({
      message: "文件大小不能超过5M!",
      type: "warning",
    });
    return false;
  }

  return true;
}
